import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "prod-offer-old__top" };
const _hoisted_2 = { class: "tabs tabs--sm" };
const _hoisted_3 = { class: "tabs__list" };
const _hoisted_4 = { class: "tabs__item" };
const _hoisted_5 = ["href", "onClick"];
const _hoisted_6 = { class: "tabs__link-label" };
import { StatusClassNames } from "../../../../types/StatusClassNames";
import { computed, inject, onMounted, onUnmounted, ref, watch } from "vue";
import { isFullyVisible } from "../../../../utils";
import { useDragToScroll } from "../../../../components/drag_scroll";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OfferTypeTabs',
    props: /*@__PURE__*/ _mergeModels({
        baseUrl: { type: String, required: true },
        types: { type: Array, required: true },
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const activeType = _useModel(__props, "modelValue");
        const tabs = computed(buildTabs);
        const activeTab = ref();
        const wrap = ref();
        const interacted = inject('interacted');
        let dragToScroll;
        if (activeType.value) {
            activeTab.value = tabs.value.find(tab => tab.title === activeType.value.name);
        }
        watch(activeTab, value => {
            activeType.value = props.types.find(type => type.name === value.title);
            setTimeout(centerActiveTab); // нужно дождаться обновления классов в элементе
        });
        onMounted(() => {
            centerActiveTab(true);
            dragToScroll = useDragToScroll(wrap.value);
        });
        onUnmounted(() => {
            dragToScroll.destroy();
            dragToScroll = undefined;
        });
        function onClick(tab) {
            if (!dragToScroll.isDragging()) {
                activeTab.value = tab;
                interacted.value = true;
            }
        }
        function centerActiveTab(direct = false) {
            const activeElement = wrap.value.querySelector(`.tabs__link.${StatusClassNames.active}`);
            if (!isFullyVisible(activeElement, wrap.value, false)) {
                if (direct) {
                    const rect = activeElement.getBoundingClientRect();
                    const wrapRect = wrap.value.getBoundingClientRect();
                    wrap.value.scrollLeft += wrapRect.width / 2 - rect.width / 2 + rect.left - wrapRect.left;
                }
                else {
                    activeElement.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
                }
            }
        }
        function buildTabs() {
            var _a;
            const tabs = [
                {
                    title: 'Все',
                    url: props.baseUrl,
                    active: !activeType.value,
                    disabled: false,
                }
            ];
            for (const type of props.types) {
                tabs.push({
                    title: type.name,
                    url: `${props.baseUrl}${type.code}/`,
                    active: type.name === ((_a = activeType.value) === null || _a === void 0 ? void 0 : _a.name),
                    disabled: type.disabled,
                });
            }
            return tabs;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "tabs__wrap",
                        ref_key: "wrap",
                        ref: wrap
                    }, [
                        _createElementVNode("ul", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                                return (_openBlock(), _createElementBlock("li", _hoisted_4, [
                                    _createElementVNode("a", {
                                        href: tab.url,
                                        class: _normalizeClass(["tabs__link", { [_unref(StatusClassNames).active]: tab.active, 'tabs__link--na': tab.disabled }]),
                                        onClick: _withModifiers(($event) => (onClick(tab)), ["prevent"])
                                    }, [
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(tab.title), 1 /* TEXT */)
                                    ], 10 /* CLASS, PROPS */, _hoisted_5)
                                ]));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ], 512 /* NEED_PATCH */)
                ])
            ]));
        };
    }
});
